<template>

	<div>

		<el-row class="barra-progreso">
			<!-- <el-progress :percentage="porcentaje" :color="colorBarra"></el-progress> -->
			<el-progress :percentage="porcentaje" :stroke-width="3" :show-text="false" :color="colorBarra"></el-progress>
		</el-row>

    </div>

</template>

<script>
export default {
		components: {},
		props: [
			'step'
		],
		data() {
			return {
				porcentaje: 100,
				tiempoTotal: this.duracionReinicio(),
				timer: null,
				colorBarra: '#18333d'
			}
		},
		computed: {
			
		},
		watch: {
			'step': function(){
				clearInterval(this.timer)
				this.tiempoTotal = this.duracionReinicio()
				this.porcentaje = 100
				this.timer = null
				if(this.step > 0){
					this.iniciarConteo()
				}
			}
		},
		methods: {
			iniciarConteo() {
				this.timer = setInterval(() => this.conteo(), 1000)
			},
			conteo() {
				let variacion = (100 / this.duracionReinicio())
				if(this.tiempoTotal >= 1){
					this.tiempoTotal--
					this.porcentaje -= variacion
				}else if(this.tiempoTotal == 0){
					this.step = 0
					this.$emit('reloadPage', 1)
				}
			},
			duracionReinicio() {
				var entorno = process.env.MIX_APP_ENV;
				if(entorno == 'local'){
					return 1200
				}else{
					return 120
				}
			}
		},
        mounted() {
            // console.log('--- progreso component mounted ---')
        }
    };

</script>

<style>
.barra-progreso .el-progress-bar__outer {
    background-color: #205984;
}
</style>